export const ELocalStorageKeys = {
  MM__TOOLBAR_STORAGE_KEY: 'MM__TOOLBAR_STORAGE_KEY',
  MM__EXPERIMENTS: 'clickstream-client.experiments',
  MM_LAST_SEEN_PRODUCTS: 'MM_LAST_SEEN_PRODUCTS',
  MM__SEARCH_HISTORY: 'MM__SEARCH_HISTORY',

  // Auth
  MM__IS_AUTH: 'MM__IS_AUTH',

  // Install ID
  MM__INSTALL_ID: 'clickstream-client.installId',

  // CitiesStore
  MM__CITIES_STORE__LAST_UPDATED_TIME: 'MM__CITIES_STORE__LAST_UPDATED_TIME',
  MM__CITIES_STORE__CURRENT_CITY_ID: 'MM__CITIES_STORE__CURRENT_CITY_ID',

  // UserStore
  MM__USER_STORE__HAS_ADULT_CHECKED: 'MM__USER_STORE__HAS_ADULT_CHECKED',
  MM__USER_STORE__IS_ADULT: 'MM__USER_STORE__IS_ADULT',
  MM__USER_STORE__USER: 'MM__USER_STORE__USER',
  MM__USER_STORE__MARKET_CUSTOMER: 'MM__USER_STORE__MARKET_CUSTOMER',

  // VPN Detector
  MM__VPN_DETECTOR__IS_CLOSED_BY_USER: 'MM__VPN_DETECTOR__IS_CLOSED_BY_USER',
  MM__VPN_DETECTOR__IS_DETECTED: 'MM__VPN_DETECTOR__IS_DETECTED',
  MM__VPN_DETECTOR__ClOSED_TIME: 'MM__VPN_DETECTOR__ClOSED_TIME',
  MM__VPN_DETECTOR__DETECTED_TIME: 'MM__VPN_DETECTOR__DETECTED_TIME',

  // Checkout
  MM__CHECKOUT__SELECTED_DELIVERY_TYPE: 'MM__CHECKOUT__SELECTED_DELIVERY_TYPE',

  // Cart
  MM__CART__LAST_UPSALE_CLOSE_TIME: 'MM__CART__LAST_UPSALE_CLOSE_TIME',
  MM__CART__LITE_BACKEND_RESPONSE: 'MM__CART__LITE_BACKEND_RESPONSE',
  MM__CART__FULL_BACKEND_RESPONSE: 'MM__CART__FULL_BACKEND_RESPONSE',
  MM__CART__FAVORITE_TOOLTIP_SHOWN: 'MM__CART__FAVORITE_TOOLTIP_SHOWN',

  // Auth SDK
  MM__AUTH_SDK__ACCESS_TOKEN: 'MM__AUTH_SDK__ACCESS_TOKEN',
  MM__AUTH_SDK__REFRESH_TOKEN: 'MM__AUTH_SDK__REFRESH_TOKEN',
  MM__AUTH_SDK__TOKEN_EXPIRE: 'MM__AUTH_SDK__TOKEN_EXPIRE',

  MM__AUTH_SDK__LEGAL_ACCESS_TOKEN: 'MM__AUTH_SDK__LEGAL_ACCESS_TOKEN',
  MM__AUTH_SDK__LEGAL_REFRESH_TOKEN: 'MM__AUTH_SDK__LEGAL_REFRESH_TOKEN',
  MM__AUTH_SDK__LEGAL_TOKEN_EXPIRE: 'MM__AUTH_SDK__LEGAL_TOKEN_EXPIRE',
  MM__AUTH_SDK__LEGAL_ACTIVE_ID: 'MM__AUTH_SDK__LEGAL_ACTIVE_ID',

  MM__AUTH_SDK__MAGNIT_ID_CODE: 'MM__AUTH_SDK__MAGNIT_ID_CODE',
  MM__AUTH_SDK__DEVICE_TAG: 'MM__AUTH_SDK__DEVICE_TAG',

  MM__AUTH_SDK__OTP_EXPIRES: 'MM__AUTH_SDK__OTP_EXPIRES',
  MM__AUTH_SDK__OTP_SENT_TO_PHONE: 'MM__AUTH_SDK__OTP_SENT_TO_PHONE',
  MM__AUTH_SDK__OTP_ATTEMPT_ID: 'MM__AUTH_SDK__OTP_ATTEMPT_ID',
  MM__AUTH_SDK__OTP_RETRY_AFTER: 'MM__AUTH_SDK__OTP_RETRY_AFTER',
  MM__AUTH_SDK__USER_ID: 'MM__AUTH_SDK__USER_ID',

  MM__CITIES_HINT_VISIBLE: 'MM__CITIES_HINT_VISIBLE',
  
  MM__IS_COOKIE_ACCEPTED: 'MM__IS_COOKIE_ACCEPTED',

  // Migration marker for MM-WEB version
  MM__MM_WEB_MIGRATION_COMPLETE: 'MM__MM_WEB_MIGRATION_COMPLETE',

  STATE: 'state',
} as const;

export type TLocalStorageKeys = (typeof ELocalStorageKeys)[keyof typeof ELocalStorageKeys];
